const MODIFY_SELECTED_FILTER = 'avisos/filter/MODIFY_SELECTED_FILTER';
const TOGGLE_FILTERS_MODAL = 'avisos/filter/TOGGLE_FILTERS_MODAL';
const UPDATE_APPLIED_FILTERS = 'avisos/filter/UPDATE_APPLIED_FILTERS';
const RESET_FILTERS = 'avisos/filter/RESET_FILTERS';
const PARTIAL_RESET_FILTERS = 'avisos/filter/PARTIAL_RESET_FILTERS';

export { MODIFY_SELECTED_FILTER, TOGGLE_FILTERS_MODAL, UPDATE_APPLIED_FILTERS, RESET_FILTERS, PARTIAL_RESET_FILTERS };
